import React, { FC } from 'react'
import { Grid, makeStyles, Theme, Typography } from '@material-ui/core'
import { useParams } from 'react-router-dom'

import { ContactForm } from 'components'

import WelcomeBG from 'assets/welcome-header.png'
import { useAppState } from '../../providers'

interface MobileContactProps {
  isSupport: boolean
  setSuccessMessage: (message: string | null) => void
  setErrorMessage: (message: string | null) => void
}

interface IParams {
  demo: string
}

export const MobileContact: FC<MobileContactProps> = ({ isSupport, setSuccessMessage, setErrorMessage }) => {
  const classes = useStyles()
  const { demo } = useParams<IParams>()
  const {
    appState: { user }
  } = useAppState()
  return (
    <div className={classes.root}>
      <Grid container>
        {!isSupport && (
          <Grid item xs={12}>
            <img className={classes.image} src={WelcomeBG} alt='Verizon 5G Logo' />
          </Grid>
        )}
        <Grid container item xs={12} className={classes.contentContainer}>
          <Grid item xs={12}>
            <Typography component='h1' variant='h5' paragraph>
              {isSupport ? 'Technical support' : 'Contact us'}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography paragraph>
              {isSupport
                ? 'Having technical difficulties? Complete the form below and someone will contact you soon.'
                : "Have questions? We're here to help."}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <ContactForm
              user={user}
              isHelpRequest={isSupport}
              setErrorMessage={setErrorMessage}
              setSuccessMessage={setSuccessMessage}
              demo={demo}
              messageHelper={
                isSupport ? 'Please let us know what issues you’re experiencing.' : 'Let us know how we can help.'
              }
            />
          </Grid>
        </Grid>
      </Grid>
    </div>
  )
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    flexGrow: 1
  },
  image: {
    width: '100%'
  },
  contentContainer: {
    padding: '2rem'
  }
}))
